import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import {
	ArticlesAccessModel,
	ArticleAccessRuleModel,
	ArticleAccessRuleShortModel,
} from 'Pages/knowledge'

export const accessApi = {
	getArticlesAccess: async (id: number) => {
		const res = await axiosDS().get<ArticlesAccessModel[]>(
			`${urls.knowledge.access}/articles?user_id=${id}`
		)
		return res.data
	},
	createAccess: async (data: ArticleAccessRuleShortModel) => {
		const res = await axiosDS().post<ArticleAccessRuleModel>(urls.knowledge.access, { data })
		return res.data
	},
	deleteAccess: async (id: number) => {
		const res = await axiosDS().delete(`${urls.knowledge.access}/${id}`)
		return res.data
	},
}
